import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

import { textColors, textSizes, TypographyProps } from "../../config/tailwind";
interface TextProps
  extends Omit<ComponentPropsWithoutRef<"p">, "color">,
    TypographyProps {}

export const Text = ({
  className,
  color = "default",
  size = "base",
  ...props
}: TextProps): ReactElement => (
  <p
    className={clsx(textSizes[size], textColors[color], className)}
    data-slot="text"
    {...props}
  />
);
